import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const VpMediaDescriptionInput = ({ ...rest }) => {
  return (
    <VpHookFormInput
      fullWidth
      maxLength={65000}
      multiline
      rows={5}
      name="description"
      label="Description"
      {...rest}
    />
  );
};

export default VpMediaDescriptionInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaDescriptionInput.jsx